<div class="section pb-48">

    <div class="pb-16" fxLayout="row" fxLayoutAlign="start center">

    </div>

    <div class="customer mb-32">
        <table class="simple">
            <thead>
                <tr>
                    <th>Return Type</th>
                    <th>Status</th>
                    <th>Refund Amount</th>
                    <th>Refund Currency</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let info of returnOrders">
                    <td *ngIf="info.orderInfo.productTypeId == 1">
                        <span class="name text-truncate">
                            Item Only
                        </span>
                    </td>
                    <td *ngIf="info.orderInfo.productTypeId == 4">
                        <span class="name text-truncate">
                            Refund Only
                        </span>
                    </td>
                    <td *ngIf="info.orderInfo.productTypeId == 5">
                        <span class="name text-truncate">
                            Item With Refund
                        </span>
                    </td>
                    <td>
                        <p class="text-truncate">
                            <span *ngIf="info.status" class="name text-truncate">
                                {{info.status}}
                            </span>
                        </p>
                        <p class="text-truncate">
                            <span *ngIf="!info.status" class="name text-truncate">
                                Created
                            </span>
                        </p>
                    </td>
                    <td>
                        <p class="text-truncate">
                            <span *ngIf="!info.status" class="name text-truncate">
                                {{info.refundAmount}}
                            </span>
                        </p>
                    </td>
                    <td>
                        <p class="text-truncate">
                            <span *ngIf="!info.status" class="name text-truncate">
                                {{info.refundCurrency}}
                            </span>
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</div>